module.exports = __webpack_public_path__ + "img/logoAuthor.d9bc0063.svg";